export const offerToSells = (state) => state.offerToSells
export const selectAllField = (state) => state.selectAllField
export const getTemplateId = (state) => state.invoiceTemplateId
export const selectedOfferToSells = (state) => state.selectedOfferToSells
export const totalOfferToSells = (state) => state.totalOfferToSells
export const selectedCustomer = (state) => state.selectedCustomer

export const selectAllInvoiceItem = (state) => state.selectAllInvoiceItem
export const selectedInvoiceItems = (state) => state.selectedInvoiceItems
export const availableInvoiceItems = (state) => state.availableInvoiceItems
export const selectAllFieldItem = (state) => state.selectAllFieldItem

export const attachments = (state) => state.attachments
export const attachmentSize = (state) => state.attachmentSize
export const totalAttachments = (state) => state.totalAttachments
export const selectedAttachments = (state) => state.selectedAttachments
export const selectAllFieldAttachment = (state) => state.selectAllFieldAttachment
export const selectedPreapprovedInvoice = (state) => state.selectedPreapprovedInvoice
